import React from 'react'
import * as styles from './style'

export interface Props {
  className?: string
}

const ReviewBlock = ({ className = '' }: Props): JSX.Element => (
  <div className={`${className} ${styles.root}`}>ReviewBlock</div>
)
export default ReviewBlock
